import React from "react";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import { formatPrincipal } from "./metricHelpers";

export default function DefaultPrimaryMetric({ sim }: MetricComponentProps) {
  const c = useCurrencyFormatter();

  return (
    <MetricItem value={formatPrincipal(sim, c)} tooltip="Principal Amount" />
  );
}
